<app-back-button />
<div class="contents">
  <div class="page-header">
    <div class="left-area">
      <span class="title">Cursos</span>
      <span class="sub-title">Adicione, consulte e edite cursos</span>
    </div>
    <div class="indicator" *ngIf="cursoCount">
      <div class="icon">
        <img src="icons/award-01.svg" alt="Country Icon" />
      </div>
      <div class="text-bg">
        <span>{{cursoCount}} Cursos</span>
      </div>
    </div>
  </div>
</div>

<app-search-bar primaryBtnLabel="Novo curso" (onPrimaryBtnClick)="showDialog()"
  (formValueChange)="handleFormValueChange($event)" [showFilterBtn]="true"
  (onFilterBtnClick)="showFilterModal()"></app-search-bar>
<div class="list">
  <ng-container *ngIf="pagination?.data?.length; else noCursos">
    <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
      (actionSelected)="onActionSelected($event)" (rowClick)="editCurso($event)"></app-table>
  </ng-container>
  <ng-template #noCursos>
    <div class="no-data">
      <app-data-void titulo="Nenhum Curso encontrado" descricao="Clique em Novo curso para criar um."></app-data-void>
    </div>
  </ng-template>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>